<div 
  class="card voucher-card shadow hover-shadow transition-fast rounded-lg h-100"
  [ngClass]="filled ? 'border-0 text-white voucher-bg-filled' : 'bg-white text-dark border'">

  <div class="card-body d-grid p-lg-4 position-relative h-100">

    <!-- TOP LEFT LOGO -->
    <div class="voucher-corner top-left">
      <img 
        [src]="'assets/img/logo-new-' + (filled ? 'white' : 'red') + '.svg'" 
        alt="Logo"
        class="voucher-logo img-fluid">
    </div>

    <!-- TOP RIGHT NAME -->
    <div *ngIf="name" class="voucher-corner top-right">
      <span class="voucher-name px-2 py-1 d-inline-block">{{ name }}</span>
    </div>

    <!-- BOTTOM LEFT QUOTA + SPEED -->
    <div class="voucher-corner bottom-left">
      <ng-container *ngIf="!quota">
        <div class="spinner-grow" style="width: 2rem; height: 2rem;" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </ng-container>
      <ng-container *ngIf="quota">
        <div class="quota-speed-wrapper">
          <!-- Quota -->
          <div class="quota-line" title="سعة الباقة" *ngIf="(limited | toBoolean) && quota && quotaUnit">
            <span class="big-bold-text">
              {{ quota }}<small class="small-unit">{{ quotaUnit }}</small>
            </span>
          </div>
          <!-- Unlimited -->
          <div class="quota-line" title="سعة الباقة" *ngIf="!(limited | toBoolean)">
            <img 
              [src]="'assets/img/unlimited_' + ((filled | toBoolean) ? 'white' : 'black') + '.png'" 
              class="img-fluid unlimited-icon"
              alt="Unlimited" />
          </div>
          <!-- Speed -->
          <div class="speed-line" title="سرعة الباقة" *ngIf="speed !== undefined">
            <ng-container *ngIf="speed != 0">
              <span class="big-bold-text">
                {{ speed }}<small class="small-unit">Mbps</small>
              </span>
            </ng-container>
            <ng-container *ngIf="speed == 0">
              <span>سرعة غير محدودة</span>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- BOTTOM RIGHT PRICE -->
    <div class="voucher-corner bottom-right">
      <div class="quota-price" title="سعر الباقة" *ngIf="price && speed != 0">
        <span>
          {{ price }}<small class="dinari-label">ديـنــار</small>
        </span>
      </div>
    </div>

  </div>
</div>
